const QUICK_LINKS = [
  { label: '热门影片', href: '#media' },
  { label: '影视资讯', href: '#cards' },
  { label: '常见问题', href: '#faq' },
  { label: '专题合集', href: '#index' },
  { label: '联系我们', href: '#contact' },
  { label: '移动观影', href: '#app' },
];

const FRIEND_LINKS = [
  { label: '合作伙伴一', href: '#' },
  { label: '合作伙伴二', href: '#' },
  { label: '合作伙伴三', href: '#' },
  { label: '合作伙伴四', href: '#' },
  { label: '合作伙伴五', href: '#' },
  { label: '合作伙伴六', href: '#' },
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-base text-white"></i>
                </span>
                <span className="font-heading text-lg font-bold text-white">51影院</span>
              </div>
              <p className="text-sm leading-relaxed text-secondary-400">
                汇聚6080影院、小a影院、8090影院、4480影院等优质影视资源，提供超清画质免费在线观看服务。免广告、不缓冲，每日更新，畅享纯净观影体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-white mb-4">快速导航</h4>
              <ul className="space-y-2">
                {QUICK_LINKS.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-white mb-4">合作伙伴</h4>
              <ul className="space-y-2">
                {FRIEND_LINKS.map((link) => (
                  <li key={link.label}>
                    <span className="text-sm text-secondary-400 whitespace-nowrap">
                      {link.label}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-white mb-4">平台特色</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-secondary-400">
                  <i className="ri-check-line text-accent-500 text-xs"></i>
                  超清画质播放
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-400">
                  <i className="ri-check-line text-accent-500 text-xs"></i>
                  全程免广告
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-400">
                  <i className="ri-check-line text-accent-500 text-xs"></i>
                  无需注册登录
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-400">
                  <i className="ri-check-line text-accent-500 text-xs"></i>
                  每日更新同步
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-secondary-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-500">
              &copy; {new Date().getFullYear()} 51影院 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#faq" className="text-xs text-secondary-500 hover:text-primary-400 transition-colors">
                常见问题
              </a>
              <a href="#contact" className="text-xs text-secondary-500 hover:text-primary-400 transition-colors">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}